import React, { useState, useContext } from "react";
import Tab from "@mui/material/Tab";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import { CircularProgress, TableCell, TableRow } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import TableScrollDiv from "../../../common/component/table/TableScrollDiv";
import { useNavigate } from "react-router-dom";
// import routeConstant from "../../../routes/utils/routeConstant";
import SwipeableViews from "react-swipeable-views";
import moment from "moment";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import Tooltip from "@mui/material/Tooltip";
import routeConstant from "../../../../route/compoent/routeConstant";
import { StoreContext } from "../../../store/index";
// import routeConstant from "../../../../route/compoent/routeConstant";

const containerRateTableHeding = [
  "Sr. No",
  "Container Type",
  "Rate per container",
];
const containerTableHeding = [
  "Sr. No",
  "Container Number",
  "Type",
  "Weight",
  "Weight unit",
  "Track",
];

function PlanDetails({
  tranportMode,
  orderPlan,
  getOrderBasedOnContainer,
  hoverLoad,
  hoverData,
}) {
  const context = useContext(StoreContext);
  const [value, setValue] = useState(0);
  const navigate = useNavigate();

  return (
    <div className="row">
      <div className="col-12 _orderFullDetailsPlanTabDiv">
        <TabContext value={value}>
          <TabList
            variant="scrollable"
            scrollButtons="auto"
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
          >
            {orderPlan.map((value, index) => {
              return (
                <Tab
                  label={
                    value.IsFreezed ? (
                      <div className="_planFreezedStar">
                        Plan {index + 1}{" "}
                        <span>
                          <StarRoundedIcon />
                        </span>
                      </div>
                    ) : (
                      <div className="_planFreezedStar">Plan {index + 1}</div>
                    )
                  }
                />
              );
            })}
          </TabList>

          <SwipeableViews
            index={value}
            onChangeIndex={(index) => setValue(index)}
          >
            {orderPlan.map((ele, index) => {
              return (
                <TabPanel
                  value={value}
                  index={index}
                  key={index}
                  className="_orderFullDetailsPlanDataTabDiv"
                >
                  <div className="_orderListFullDetailsComponentTableDiv">
                    <table>
                      <tbody>
                        <tr>
                          <th>Origin Country</th>
                          <th>:</th>
                          <td>
                            {ele?.PlanningOriginCountryName ?? ""}{" "}
                            {ele?.PlanningOriginCountryCode
                              ? `(${ele?.PlanningOriginCountryCode})`
                              : ""}
                          </td>
                          <th>Origin Port</th>
                          <th>:</th>
                          <td>
                            {ele?.PlanningOriginPortName ?? ""}{" "}
                            {ele?.PlanningOriginPortCode
                              ? `(${ele?.PlanningOriginPortCode})`
                              : ""}
                          </td>
                        </tr>
                        <tr>
                          <th>Destination Country</th>
                          <th>:</th>
                          <td>
                            {ele?.PlanningDestinationCountryName ?? ""}{" "}
                            {ele?.PlanningDestinationCountryCode
                              ? `(${ele?.PlanningDestinationCountryCode})`
                              : ""}
                          </td>
                          <th>Destination Port</th>
                          <th>:</th>
                          <td>
                            {ele?.PlanningDestinationPortName ?? ""}{" "}
                            {ele?.PlanningDestinationPortCode
                              ? `(${ele?.PlanningDestinationPortCode})`
                              : ""}
                          </td>
                        </tr>
                        <tr>
                          <th>Departure Date</th>
                          <th>:</th>
                          <td>
                            {ele?.PlanningEstimatedDepart ===
                            "1900-01-01 00:00:00.000"
                              ? ""
                              : ele?.PlanningEstimatedDepart
                              ? moment(ele?.PlanningEstimatedDepart).format(
                                  "MM-DD-YYYY"
                                )
                              : ""}
                          </td>
                          <th>Cut Off Date</th>
                          <th>:</th>
                          <td>
                            {ele?.PlanningCutOfDate ===
                            "1900-01-01 00:00:00.000"
                              ? ""
                              : ele?.PlanningCutOfDate
                              ? moment(ele?.PlanningCutOfDate).format(
                                  "MM-DD-YYYY"
                                )
                              : ""}
                          </td>
                        </tr>
                        <tr>
                          <th>Arrival Date</th>
                          <th>:</th>
                          <td>
                            {ele?.PlanningEstimatedArrival ===
                            "1900-01-01 00:00:00.000"
                              ? ""
                              : ele?.PlanningEstimatedArrival
                              ? moment(ele?.PlanningEstimatedArrival).format(
                                  "MM-DD-YYYY"
                                )
                              : ""}
                          </td>
                          <th>Order Ready Date </th>
                          <th>:</th>
                          <td>
                            {ele?.PlanningOrderReadyDate ===
                            "1900-01-01 00:00:00.000"
                              ? ""
                              : ele?.PlanningOrderReadyDate
                              ? moment(ele?.PlanningOrderReadyDate).format(
                                  "MM-DD-YYYY"
                                )
                              : ""}
                          </td>
                        </tr>
                        <tr>
                          {tranportMode.includes("AIR") ? null : (
                            <>
                              <th>Vessel</th>
                              <th>:</th>
                              <td>{ele?.PlanningVessel ?? ""}</td>
                            </>
                          )}

                          <th>
                            {tranportMode.includes("AIR")
                              ? "Flight Number"
                              : "Voyage number"}
                          </th>
                          <th>:</th>
                          <td
                            colSpan={tranportMode.includes("AIR") ? "4" : "1"}
                          >
                            {ele?.PlanningVoyage ?? ""}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {tranportMode.includes("AIR")
                              ? "Airline"
                              : "Carrier"}
                          </th>
                          <th>:</th>
                          <td>{ele?.PlanningCarrierCode ?? ""}</td>
                          <th>Final Destination</th>
                          <th>:</th>
                          <td>{ele?.PlanningFinalDestination ?? ""}</td>
                        </tr>
                        <tr>
                          <th>
                            {tranportMode.includes("AIR")
                              ? "Master Airway Bill Number"
                              : "Master Bill of Lading Number"}
                          </th>
                          <th>:</th>
                          <td>{ele?.PlanningMasterBill ?? ""}</td>
                          <th>Forwarder/Carrier</th>
                          <th>:</th>
                          <td>{ele?.PlanningForwarderCarrier ?? ""}</td>
                        </tr>
                        {/* {context.orderUserAccess?.ViewRates ? (
                          <tr>
                            <th>Rates</th>
                            <th>:</th>
                            <td>{ele?.PlanningRates ?? ""}</td>
                          </tr>
                        ) : null} */}
                      </tbody>
                    </table>
                  </div>
                  {ele?.OrderPlanningContainerCollection?.length ? (
                    <>
                      <h5>Containers</h5>
                      <TableScrollDiv column={containerTableHeding}>
                        {ele.OrderPlanningContainerCollection.map(
                          (item, index) => {
                            return (
                              <TableRow>
                                <TableCell>{index + 1}</TableCell>
                                <Tooltip
                                  placement="right"
                                  title={
                                    <div className="hoverBox">
                                      {hoverLoad ? (
                                        <CircularProgress color="inherit" />
                                      ) : (
                                        <div>
                                          {hoverData.map((item) => {
                                            return (
                                              <div>
                                                <h5>
                                                  Order no.:
                                                  {item.OrderHeader.OrderNumber}
                                                  {item.OrderHeader
                                                    .SplitNumber !== "0"
                                                    ? `/${item.OrderHeader.SplitNumber}`
                                                    : ""}
                                                </h5>
                                                <table class="table table-sm hoverTable">
                                                  <thead>
                                                    <tr>
                                                      <th scope="col">
                                                        Item No.
                                                      </th>
                                                      <th scope="col">
                                                        Description
                                                      </th>
                                                      <th scope="col">Weigh</th>
                                                      <th scope="col">
                                                        Volume
                                                      </th>
                                                      <th scope="col">
                                                        Quantity received
                                                      </th>
                                                      <th scope="col">
                                                        Outer Packs
                                                      </th>
                                                    </tr>
                                                  </thead>

                                                  {item.OrderLinesCollection
                                                    .length > 0 ? (
                                                    item.OrderLinesCollection.map(
                                                      (line) => {
                                                        return (
                                                          <tbody>
                                                            <tr>
                                                              <th scope="row">
                                                                {
                                                                  line.LinePartNumber
                                                                }
                                                              </th>
                                                              <td>
                                                                {
                                                                  line.LineDescription
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  line.LineActualWeight
                                                                }
                                                                {
                                                                  line.LineUnitOfWeight
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  line.LineActualVolume
                                                                }
                                                                {
                                                                  line.LineUnitOfVolume
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  line.LineRecievedQuantity
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  line.LineOuterPacks
                                                                }
                                                                {
                                                                  line.LineOuterPacksUnit
                                                                }
                                                              </td>
                                                            </tr>
                                                          </tbody>

                                                          // <p>Item No.: {line.LinePartNumber},{"  "}
                                                          //   Description: {line.LineDescription},{"  "}
                                                          //   Weigh: {line.LineActualWeight}{line.LineUnitOfWeight},{"  "}
                                                          //   Volume:{line.LineActualVolume}{line.LineUnitOfVolume},{"  "}
                                                          //   Quantity received: {line.LineRecievedQuantity},{"  "}
                                                          //   Outer Packs:{line.LineOuterPacks}{line.LineOuterPacksUnit},{"  "}</p>
                                                        );
                                                      }
                                                    )
                                                  ) : (
                                                    <p>
                                                      Line detail not added{" "}
                                                    </p>
                                                  )}
                                                </table>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      )}
                                    </div>
                                  }
                                  arrow
                                >
                                  <TableCell
                                    onMouseOver={() => {
                                      getOrderBasedOnContainer(
                                        item.ContainerNumber
                                      );
                                    }}
                                  >
                                    {item.ContainerNumber}
                                  </TableCell>
                                </Tooltip>

                                <TableCell>{item.ContainerType}</TableCell>
                                <TableCell>{item?.ContainerWeight}</TableCell>
                                <TableCell>
                                  {item?.ContainerWeightUnit.toLowerCase()}
                                </TableCell>
                                <TableCell>
                                  <span
                                    onClick={() =>
                                      navigate(
                                        routeConstant.ORDER_LIST_FULL_MILESTONE,
                                        {
                                          state: {
                                            orderData:
                                              ele.OrderPlanningContainerCollection,
                                            carrier: ele.PlanningCarrierSacCode,
                                            masterBill: ele.PlanningMasterBill,
                                          },
                                        }
                                      )
                                    }
                                  >
                                    <OpenInNewIcon />
                                  </span>
                                </TableCell>
                              </TableRow>
                            );
                          }
                        )}
                      </TableScrollDiv>
                    </>
                  ) : null}

                  {context.orderUserAccess?.ViewRates ? (
                    <>
                      <h5 style={{ marginTop: 30 }}>Rate Per Container</h5>

                      {ele?.OrderPlanningContainerRatesCollection &&
                      ele?.OrderPlanningContainerRatesCollection?.length ? (
                        <TableScrollDiv column={containerRateTableHeding}>
                          {ele.OrderPlanningContainerRatesCollection.map(
                            (item, index) => {
                              return (
                                <TableRow>
                                  <TableCell>{index + 1}</TableCell>
                                  <TableCell>{item.ContainerRType}</TableCell>
                                  <TableCell>
                                    {item?.ContainerTypeRate}
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          )}
                        </TableScrollDiv>
                      ) : null}
                    </>
                  ) : null}
                </TabPanel>
              );
            })}
          </SwipeableViews>
        </TabContext>
      </div>
    </div>
  );
}

export default PlanDetails;
